import { useEffect, useState } from "react";
import getPosts from "../Services/requests/getPosts";
import usePopupCtx from "./usePopupCtx";

const usePosts = (toGet, postsToGet, setShowButton, toFilter) => {
	const [loading, setLoading] = useState(true);
	const [posts, setPosts] = useState([]);
	const [paginationNumb, setPaginationNumb] = useState(0);
	const popUpCtx = usePopupCtx();

	const changePaginationNumb = () => {
		setPaginationNumb((prev) => (prev += postsToGet));
	};

	useEffect(() => {
		if (!loading) {
			setLoading(true);
		}
		getPosts(toGet, paginationNumb, postsToGet)
			.then((newPosts) => {
				//obtengo el ultimo post dentro del array de posts
				const lastPostIndex = posts.length;
				const lasPost = posts[lastPostIndex - 1];
				if (toFilter) {
					//filtro el slug dado en la funcion y si existe ya un ultimo post tambien lo filtro para que no se repita dos veces en el array
					const filteredPosts = newPosts.filter(
						(post) => post.slug !== toFilter && post.slug !== lasPost?.slug
					);
					//por preferencia se quiere que al precionar el boton de optener mas posts al arreglo de posts siempre se le agreguen el numero de posts dado en postsToGet , pero como arriba se filtra el slug es posible que vaya a retornar un numero de posts menor al deseado. Para evitar esto checamos el pagination numb y los posts retornados y si son menores a lo especificado en postsToGet hacemos una nueva peticion para obtener los posts restantes y asi llegar a la cantidad especificada en postsToGet, si no es el caso significa que no hay mas posts disponibles. Este proceso solo se realizara si con anterioridad se ha usado el boton para obtener mas posts por eso se checa el pagination numb en el condicional.
					if (filteredPosts.length < postsToGet) {
						const missingPostsNumb = +postsToGet - +filteredPosts.length;
						const paginationNumbForMissingPosts =
							paginationNumb + +filteredPosts.length + 1;
						getPosts(toGet, paginationNumbForMissingPosts, missingPostsNumb)
							.then((missingPosts) => {
								if (missingPosts.length === 0) {
									setShowButton(false);
									// Si el pagination numb es igual a 0 significa que se ha echo una sola peticion y si ademas los posts son menores a los que se quiere obtener signica que en la primera peticion se obtuvieron todos los posts disponibles por lo que no es necesario mostrar una notificacion que indique que no has mas posts disponibles
									if (paginationNumb > 0) {
										popUpCtx.showPopUp({
											message: `No hay más ${
												toGet === "casos-exitos" ? "casos de éxito" : toGet
											} disponibles!`,
										});
									}
								}
								setPosts((prev) => [...prev, ...missingPosts]);
								return setLoading(false);
							})
							.catch((e) => {
								throw new Error("Error al obtener missing posts.");
							});
					}
					setPosts((prev) => [...prev, ...filteredPosts]);
					return setLoading(false);
				}
				if (newPosts.length < postsToGet) {
					setShowButton(false);
					popUpCtx.showPopUp({
						message: `No hay más ${
							toGet === "casos-exitos" ? "casos de éxito" : toGet
						} disponibles!`,
					});
				}
				setPosts((prev) => [...prev, ...newPosts]);
				return setLoading(false);
			})
			.catch((e) =>
				popUpCtx.showPopUp({
					message: `Ha ocurrido un error, por favor intente más tarde`,
				})
			);
		// eslint-disable-next-line
	}, [paginationNumb]);

	return { loading, posts, changePaginationNumb, paginationNumb };
};

export default usePosts;
